<script>
  import { html } from 'common-tags';

  import ChoiceInput from './choice-input.svelte';

  export let value;

  export let onChange = () => {};

  const options = [
    {
      label: 'none',
      value: 'none',
      html: '<svg width="1rem" height="1rem" viewBox="0 -1 17 17"><rect width="16" height="12" fill="currentColor" /></svg>'
    },
    {
      label: 'Wave',
      value: "path('M0 20 s85.8575 -30.8855 168 0 C250.1425 50 296.5605 60 336 60 H0Z')",
      html: html`<svg width="1rem" height="1rem" viewBox="0 -1 17 17">
        <path d="M0 0 L0 10 s4.4 -3.5 8.5 0 C12.7 13 15 14 17 14 V0 Z" fill="currentColor" />
      </svg>`
    },
    {
      label: 'Curve',
      value: "path('M 0 0 C 105 39 296.5605 60 336 60 H 0 Z')",
      html: html`<svg width="1rem" height="1rem" viewBox="0 -1 17 17">
        <path d="M0 7 C5.3 12, 15 16, 16 16 V0 L0 0Z" fill="currentColor" />
      </svg>`
    },
    {
      label: 'Angle',
      value: 'polygon(0 60px, 100% 60px, 100% 30px, 0 60px)',
      html: html`<svg width="1rem" height="1rem" viewBox="0 -1 17 17">
        <polygon points="0 0, 0 16, 16 8, 16 0" fill="currentColor" />
      </svg>`
    }
  ];
</script>

<ChoiceInput editable {value} {options} {onChange} />
